import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import { CardExpansionHeader } from 'components/CardExpansion/CardExpansionHeader'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useActionOnProvisionImpairmentReversalStatusMutation,
} from 'generated/graphql'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { ChangeEvent, FC, useContext, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ProvisionImpairmentReversalDetailContent } from '../ProvisionImpairmentReversalDetail/ProvisionImpairmentReversalDetailContent'
import { ReversePredevalueDetailContent } from '../ProvisionImpairmentReversalDetail/ReversePredevalueDetailContent'

interface PIListProps {
  filteredList: any[]
  listLoading: boolean
  listStatus: string
  userList: any[]
  fetchMore: Function
  setOriginalListing: Function
  postIDs: Set<string>
  setPostIDs: React.Dispatch<React.SetStateAction<Set<string>>>
  hasMore: boolean
  CompanyID: string
}

export const ProvisionImpairmentReversalPostingList: FC<PIListProps> = ({
  filteredList,
  listLoading,
  listStatus,
  userList,
  fetchMore,
  setOriginalListing,
  postIDs,
  setPostIDs,
  hasMore,
  CompanyID,
}) => {
  const { handlePermDisabled } = usePermissionChecker()
  const [selectAll, setSelectAll] = useState(false)
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const [errorDia, setErrorDia] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [isReject, setIsReject] = useState(false)
  const [rejectDialogInput, setRejectDialogInput] = useState<any>(null)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(SnackBarContext)

  const [
    actionOnStatus,
    { loading: actionLoading },
  ] = useActionOnProvisionImpairmentReversalStatusMutation({
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setPostIDs(new Set())
      setSelectAll(false)
      setIsReject(false)
      setRejectDialogInput(null)
      const updatedList = filteredList.filter(
        (item: any) => !postIDs.has(item.provision_impairment_reversal_id)
      )
      setOriginalListing(updatedList)
    },
  })

  useEffect(() => {
    if (isReject && rejectDialogInput && postIDs.size > 0) {
      actionOnStatus({
        variables: {
          CompanyID: CompanyID,
          provision_impairment_reversal_id: Array.from(postIDs),
          ApprovalStatus: ApprovalStatus.Rejected,
          input: {
            RejectionRemark: rejectDialogInput.RejectionRemark,
            RejectionDate: new Date().toISOString().split('T')[0],
          },
        },
      })
    }
  }, [isReject, rejectDialogInput])

  const handleCheckBoxChange = (
    e: ChangeEvent<HTMLInputElement>,
    reversalID: string
  ) => {
    const newSet = new Set(postIDs)
    if (e.target.checked) {
      newSet.add(reversalID)
    } else {
      newSet.delete(reversalID)
      setSelectAll(false)
    }
    setPostIDs(newSet)
  }

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    setSelectAll(isChecked)

    const newSet = new Set(
      isChecked
        ? checkedFilteredList.map(el => el.provision_impairment_reversal_id)
        : []
    )
    setPostIDs(newSet)
  }

  const checkedFilteredList =
    filteredList && filteredList.length > 0 ? filteredList : []

  const onSubmitApprove = () => {
    if (postIDs.size === 0) return

    actionOnStatus({
      variables: {
        CompanyID: CompanyID,
        provision_impairment_reversal_id: Array.from(postIDs),
        ApprovalStatus: ApprovalStatus.Completed,
        input: null,
      },
    })
  }

  return (
    <>
      {(listLoading || actionLoading) && <Loading />}
      <ContentWrapper overflow>
        {listStatus === 'SUBMIT' && checkedFilteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              value=""
              color="primary"
              onChange={handleSelectAll}
              style={{
                marginLeft: '-5px',
                marginTop: '5px',
              }}
              checked={
                postIDs?.size > 0 && postIDs.size === checkedFilteredList.length
              }
              disabled={handlePermDisabled({
                companyID: CompanyID,
                permEnum:
                  AcctPermission.FixedAssetsProvisionImpairmentReversalApproveReject,
              })}
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {checkedFilteredList === undefined ||
          checkedFilteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="dd a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={checkedFilteredList.length}
              next={() => {
                const currentLength = checkedFilteredList.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                  },
                })
              }}
              hasMore={hasMore}
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {checkedFilteredList.map((el, index) => (
                <CardExpansion
                  key={index}
                  summary={
                    <ListItem>
                      {listStatus === 'SUBMIT' && (
                        <FormControl
                          component="fieldset"
                          style={{
                            marginLeft: '10px',
                            marginRight: '-5px',
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                value=""
                                color="primary"
                                onChange={e =>
                                  handleCheckBoxChange(
                                    e,
                                    el.provision_impairment_reversal_id
                                  )
                                }
                                style={{
                                  marginLeft: '10px',
                                  marginRight: '-5px',
                                }}
                                checked={postIDs.has(
                                  el.provision_impairment_reversal_id
                                )}
                                disabled={handlePermDisabled({
                                  companyID: CompanyID,
                                  permEnum:
                                    AcctPermission.FixedAssetsProvisionImpairmentReversalApproveReject,
                                })}
                              />
                            }
                            label=""
                          />
                        </FormControl>
                      )}
                      <ListItemText
                        primary={
                          <>
                            <span className="desc date-width">
                              {`${formatDate(el?.reversal_date)}` || 'N/A'}
                            </span>
                            <span className="xsTitle flex-space">
                              {el?.DocNo}
                            </span>
                            <span className={`xsTitle`}>{el?.Asset?.name}</span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid container>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={6}>
                                  <span className="desc flex-space">
                                    {el?.Asset?.Category?.name}
                                  </span>{' '}
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  style={{ textAlign: 'right' }}
                                >
                                  <span className="desc flex-space">
                                    {'Acc. Impairment '}
                                    <span
                                      style={{
                                        textDecoration: 'line-through',
                                      }}
                                    >
                                      {amtStr(el?.accumulated_impairment)}
                                    </span>
                                    <span> → </span>
                                    <span style={{ color: 'orange' }}>
                                      {amtStr(
                                        el?.accumulated_impairment_reversal
                                      )}
                                    </span>
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <span className="desc">
                                    {el?.description}
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />
                    </ListItem>
                  }
                >
                  <ProvisionImpairmentReversalDetailContent
                    listEl={el}
                    userList={userList}
                    listStatus={listStatus}
                    mode={'SUBMIT'}
                  />
                  <CardExpansionHeader title="Provision Impairment Adjustment Reversal" />
                  <ReversePredevalueDetailContent listEl={el} />
                </CardExpansion>
              ))}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>

      {listStatus === 'SUBMIT' && (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => setOpenRejectDialog(true),
              color: 'secondary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.FixedAssetsProvisionImpairmentReversalApproveReject,
                  }),
              },
            },
            {
              name: 'Approve',
              onClick: onSubmitApprove,
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.FixedAssetsProvisionImpairmentReversalApproveReject,
                  }),
              },
            },
          ]}
        />
      )}

      <RejectDialog
        data={{ DocNo: `${postIDs.size} record(s) selected` }}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg="Error"
      />
    </>
  )
}
